module.exports = __webpack_public_path__ + "img/dodge_thumbnail.0fc24e68.png";